import { render, staticRenderFns } from "./editable-editor.vue?vue&type=template&id=650031f7&scoped=true&"
import script from "./editable-editor.vue?vue&type=script&lang=js&"
export * from "./editable-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650031f7",
  null
  
)

export default component.exports